import * as types from './type';


const initialState = {
    detail: '',
    selfListing: '',
    rentedProperties: '',
    salesProperties: '',
    relatedProperties: '',
    featuredProperties: '',
    featuredPropertiesObj: '',
    latestProperties: '',
    propertiesResults: ''
};



export default function propertyReducer(state = initialState, action) {

  switch (action.type) {
      
    case types.GET_PROPERTY_DETAIL: {
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          detail: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.UPDATE_PROPERTY: {
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          detail: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_SELFT_PROPERTY_LISTING: {
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          selfListing: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_RENTED_PROPERTIES: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          rentedProperties: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_SALE_PROPERTIES: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          salesProperties: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_RELATED_PROPERTIES: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          relatedProperties: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_FEATURED_PROPERTIES: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          featuredProperties: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_FEATURED_PROPERTIES_WITH_PAGINATION: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          featuredPropertiesObj: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_LATEST_PROPERTIES_WITH_PAGINATION: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          latestProperties: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.SEARCH_PROPERTIES: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          propertiesResults: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    default: {
      return {
        ...state
      };
    }
    
  }

}